import {Routes} from "@angular/router";
import {AuthenticationGuard, AuthorizationGuard} from "@softline/auth";
import {importProvidersFrom} from "@angular/core";
import {
  ConnectionHttpService,
  RemoteCollectionStore,
  SOFTLINE_SERVICE_HTTP,
  SOFTLINE_STORE_ENTITY_SERVICE,
  SOFTLINE_STORE_REMOTE_OBJECT_SERVICE,
  SoftlineEntityService,
  SoftlineObjectService,
  StoreModule
} from "@softline/core";
import {
  SOFTLINE_FEATURE_REGISTRATION_ADMIN_ADMIN,
  SOFTLINE_FEATURE_REGISTRATION_ADMIN_CONTACTS,
  SOFTLINE_FEATURE_REGISTRATION_ADMIN_CUSTOMERS,
  SOFTLINE_PERMISSION_REGISTRATION_ADMIN
} from './registration-admin.shared';
import {CONTACT_RESOURCE_PATH, CUSTOMER_RESOURCE_PATH, REGISTRATIONS_RESOURCE_PATH} from './registration-admin.api';
import {RegistrationAdminStore} from './store/registration-admin.store';
import {UserResourceService} from './services/user-resource.service';

export const portalRegistrationAdminRoutes: Routes = [
  {
    path: 'registration-admin/:id',
    loadComponent: () => import('./pages/registration-admin.component').then(o => o.RegistrationAdminComponent),
    canActivate: [AuthenticationGuard, AuthorizationGuard],
    data: {permission: SOFTLINE_PERMISSION_REGISTRATION_ADMIN},
    providers: [
      UserResourceService,
      importProvidersFrom(
        StoreModule.forFeature({
          name: SOFTLINE_FEATURE_REGISTRATION_ADMIN_CONTACTS,
          feature: RemoteCollectionStore.feature,
          providers: [{
            provide: SOFTLINE_STORE_ENTITY_SERVICE,
            useFactory: (service: ConnectionHttpService) => new SoftlineEntityService(service, CONTACT_RESOURCE_PATH),
            deps: [SOFTLINE_SERVICE_HTTP]
          }]
        }),
        StoreModule.forFeature({
          name: SOFTLINE_FEATURE_REGISTRATION_ADMIN_CUSTOMERS,
          feature: RemoteCollectionStore.feature,
          providers: [{
            provide: SOFTLINE_STORE_ENTITY_SERVICE,
            useFactory: (service: ConnectionHttpService) => new SoftlineEntityService(service, CUSTOMER_RESOURCE_PATH),
            deps: [SOFTLINE_SERVICE_HTTP]
          }]
        }),
        StoreModule.forFeature({
          name: SOFTLINE_FEATURE_REGISTRATION_ADMIN_ADMIN,
          feature: RegistrationAdminStore.feature,
          providers: [
            {
              provide: SOFTLINE_STORE_REMOTE_OBJECT_SERVICE,
              useFactory: (service: ConnectionHttpService) => new SoftlineObjectService(service, REGISTRATIONS_RESOURCE_PATH),
              deps: [SOFTLINE_SERVICE_HTTP]
            },
            {
              provide: UserResourceService,
              useFactory: (service: ConnectionHttpService) => new UserResourceService(service),
              deps: [SOFTLINE_SERVICE_HTTP]
            }
          ]
        }),
      ),
    ]
  },
];
